import * as React from "react";
import { notification, Modal, Input } from "antd";
import { nameOfKind, parentLink, request, resourceLink } from "../../services/cpln";
import { clearItem } from "../../services/utils";
import { useNavigate } from "react-router-dom";
import { CpLabel } from "../../pages/gvc/testNewForm/CpLabel";
import { CpFormItem } from "../../pages/gvc/testNewForm/CpFormItem";

interface Props {
  kind: string;
  link: string;
  name: string;
  onClose: () => void;
  clone: (item: any) => Promise<void>;
}

export const CloneModal: React.FC<Props> = ({ kind, link, name, clone, onClose }) => {
  const [nameInput, setNameInput] = React.useState("");
  const [descriptionInput, setDescriptionInput] = React.useState("");

  const [isLoading, setIsLoading] = React.useState(false);
  const navigate = useNavigate();

  async function tryConfirmClone() {
    try {
      if (!nameInput) return;

      setIsLoading(true);

      let _itemToClone: any;

      const { data } = await request({ url: link });
      _itemToClone = data;

      // override description
      if (descriptionInput) {
        _itemToClone.description = descriptionInput;
      } else {
        _itemToClone.description = nameInput;
      }

      // override name
      _itemToClone.name = nameInput;

      clearItem(_itemToClone);

      await clone(_itemToClone);
      notification.success({
        message: "Success",
        description: `Cloned ${nameOfKind(kind)}`,
      });

      onClose();
      setIsLoading(false);

      navigate(`/console${parentLink(kind as any)}`);
      setTimeout(() => {
        navigate(`/console${resourceLink(kind as any, _itemToClone.name)}`);
      }, 200);
    } catch (e) {
      let errorMessage = e?.response?.data?.message;
      if (!errorMessage) errorMessage = e.message;
      notification.warning({
        message: "Failed",
        description: errorMessage,
      });
      setIsLoading(false);
    }
  }

  return (
    <Modal
      open={true}
      title={`Clone ${nameOfKind(kind)} Item`}
      onCancel={onClose}
      onOk={tryConfirmClone}
      cancelText={`Cancel`}
      okText={`Clone`}
      cancelButtonProps={{ type: "default", disabled: isLoading }}
      okButtonProps={{ type: "primary", disabled: isLoading || !nameInput, loading: isLoading }}
      maskClosable={false}
      destroyOnHidden
    >
      <div className="flex flex-col" style={{ padding: "16px 8px 0" }}>
        <CpFormItem>
          <CpLabel name="skip">Name</CpLabel>
          <Input value={nameInput} onChange={(e) => setNameInput(e.target.value)} />
        </CpFormItem>
        <CpFormItem>
          <CpLabel name="skip">Description</CpLabel>
          <Input value={descriptionInput} onChange={(e) => setDescriptionInput(e.target.value)} />
        </CpFormItem>
      </div>
    </Modal>
  );
};
